import type { FoursquarePlacePhoto } from '@/types/itinerary';

// FSQ photo URLs are built as `${prefix}${size}${suffix}`. We use the
// `width${px}` form so we get a proportional resize without needing to know
// the height — FSQ scales the original maintaining aspect ratio.
export const foursquarePhotoUrl = (photo: FoursquarePlacePhoto, width: number): string =>
  `${photo.prefix}width${width}${photo.suffix}`;
